import {Component, Input} from '@angular/core';
import {NavParams} from "ionic-angular/index";

/**
 * Generated class for the VipIntroComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'vip-intro',
  templateUrl: 'vip-intro.html'
})
export class VipIntroComponent {

  @Input() vip_menu;

  constructor(params:NavParams) {
    console.log('Hello VipIntroComponent Component');
    this.vip_menu = params.get('vip_menu');

  }


}



// WEBPACK FOOTER //
// ./src/components/vip-intro/vip-intro.ts